import React from "react";
import UnmergedLeads from "./Unmerged/UnmergedLeads";

interface CustomProps {
  setToggle?: any;
  toggle?: any;
}

/** Standalone Unmerged Leads page (sidebar route — not Archive tab). */
const UnmergedLeadsPage = (_props: CustomProps) => {
  return (
    <div className="flex h-[calc(100vh-68px)] max-h-[calc(100vh-68px)] flex-col overflow-hidden bg-white p-4 sm:p-5 lg:p-6">
      <UnmergedLeads />
    </div>
  );
};

export default UnmergedLeadsPage;
